export const payloadIdItem = (id) => ({
    name: "payloadId",
    binary: "uint",
    size: 1,
    custom: id,
    omit: true,
});
//# sourceMappingURL=payloadId.js.map